module.exports = __webpack_public_path__ + "img/donut.47f10ed6.png";